/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentNoteText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentNoteText({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/Notes/Content/AppointmentNoteText"
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let eventAppointmentNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'event_appointment_note',
path: 'note',
})
let dtTypographyFontsizeMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.ms'
        })
  return (<React.Fragment
>
<div
  data-testid="AppointmentNoteText.Vertical"
  data-view-path={viewPath}
 style={{'--c-1-ZKepGH': dtColorsBlack}}
 className={`views-block ${styles.Vertical}`}
>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 fontSize={dtTypographyFontsizeMs}
 lineHeight={13}
 data="event_appointment_note.note"
 html={eventAppointmentNoteNoteValueData}
/>
</div>
{children}
</React.Fragment>)
}